import { Box, createStyles, makeStyles, Theme, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '../../../common/Alert/Alert';
import { CheckConnectivitiyResultsConstants } from '../../../Core/constants/AppConstants';
import { TestResults } from '../../../types';
import { getDNSlookupAlertVariant } from '../../../utils';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    links: {
      textDecoration: 'none',
    },
  });
});

const CheckDNSLookupResults = ({ results }: { results: TestResults }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const { results: connectivitiyResults } = results;

  const {
    documentationLinks: { dnsLookupTestDocumentation },
  } = CheckConnectivitiyResultsConstants;

  return (
    <Box padding={2}>
      <Alert variant={getDNSlookupAlertVariant(results)}>
        <Typography variant="body1">
          <strong>
            {connectivitiyResults.dnsLookupTest?.totalDomains !==
            connectivitiyResults.dnsLookupTest?.domainsReachable ? (
              <>
                {t('TEST_FAILURE.DNS_LOOKUP')} {t('TEST_FAILURE.CLICK_HERE')}
                <a className={classes.links} rel="noreferrer" target="_blank" href={dnsLookupTestDocumentation}>
                  {t('TEST_FAILURE.HERE')}
                </a>
                {t('TEST_FAILURE.MORE_INFORMATION')}
              </>
            ) : (
              <> {t('TEST_SUCCESSFUL.DNS_LOOKUP_TEST')}</>
            )}
          </strong>
        </Typography>
      </Alert>
    </Box>
  );
};

export { CheckDNSLookupResults };
